import "core-js/modules/es6.function.name";
import _objectSpread from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/*eslint-disable*/
import request from '@/utils/request';
export function add(data) {
  return request({
    url: 'api/csCompany',
    method: 'post',
    data: data
  });
}
export function menuAdd(data) {
  return request({
    url: 'api/csCompany/menu/add',
    method: 'post',
    data: data
  });
}
export function del(ids) {
  return request({
    url: 'api/csCompany/',
    method: 'delete',
    data: ids
  });
}
export function edit(data) {
  return request({
    url: 'api/csCompany',
    method: 'put',
    data: data
  });
}
export function detail(id) {
  return request({
    url: 'api/csCompany/detail?id=' + id,
    method: 'get'
  });
}
export function getMenusTree() {
  return request({
    url: 'api/csCompany/tree',
    method: 'get'
  });
}
export function treeAuth(id) {
  return request({
    url: 'api/csCompany/tree/auth?id=' + id,
    method: 'get'
  });
}
export function selectParty() {
  return request({
    url: 'api/csParty/select',
    method: 'get'
  });
}

/**
 * 获取系统配置
 */
export function getBaseConfig() {
  return _getBaseConfig.apply(this, arguments);
}

/**
 * 获取甲方详情
 * @returns {*}
 */
function _getBaseConfig() {
  _getBaseConfig = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var h5Domain;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return request({
            url: 'api/csBaseConfig/h5/domain',
            method: 'get'
          });
        case 3:
          h5Domain = _context.sent;
          return _context.abrupt("return", {
            h5Domain: h5Domain
          });
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", {
            h5Domain: ''
          });
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _getBaseConfig.apply(this, arguments);
}
export function selectPartyDetail() {
  return _selectPartyDetail.apply(this, arguments);
}
function _selectPartyDetail() {
  _selectPartyDetail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var data;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return request({
            url: 'api/csParty/detailImage',
            method: 'get'
          });
        case 3:
          data = _context2.sent;
          return _context2.abrupt("return", data || {});
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);
          return _context2.abrupt("return", {});
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return _selectPartyDetail.apply(this, arguments);
}
export function selectCompany() {
  return _selectCompany.apply(this, arguments);
}
function _selectCompany() {
  _selectCompany = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var all,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          all = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
          _context3.prev = 1;
          _context3.next = 4;
          return request({
            url: 'api/csCompany/select?all=' + all,
            method: 'get'
          });
        case 4:
          return _context3.abrupt("return", _context3.sent);
        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](1);
          return _context3.abrupt("return", []);
        case 10:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 7]]);
  }));
  return _selectCompany.apply(this, arguments);
}
export function selectTree() {
  return _selectTree.apply(this, arguments);
}

// 启用
function _selectTree() {
  _selectTree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var data;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return request({
            url: 'api/csParty/tree',
            method: 'get'
          });
        case 3:
          data = _context4.sent;
          return _context4.abrupt("return", data || []);
        case 7:
          _context4.prev = 7;
          _context4.t0 = _context4["catch"](0);
          return _context4.abrupt("return", []);
        case 10:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 7]]);
  }));
  return _selectTree.apply(this, arguments);
}
export function enable(data) {
  return request({
    url: 'api/csCompany/enable',
    method: 'put',
    data: data
  });
}

// 禁用
export function disable(data) {
  return request({
    url: 'api/csCompany/disable',
    method: 'put',
    data: data
  });
}

/**
 * 作业类型设置
 * @param data
 * @returns {*}
 */
export function typeAdd(data) {
  return request({
    url: 'api/csCompany/type/setting',
    method: 'post',
    data: data
  });
}

/**
 * 获取作业类型
 * @param id
 * @returns {*}
 */
export function typeAuth(id) {
  return request({
    url: 'api/csCompany/type/auth?id=' + id,
    method: 'get'
  });
}

/**
 * 获取乙方拥有的作业类型字典
 *
 * @param params.companyId
 * @param params.code
 * @param params.name
 * @return {Promise<(T | {label: *, value: *})[]|Array>}
 */
export function loadCompanyWorkPlanTypeDict() {
  return _loadCompanyWorkPlanTypeDict.apply(this, arguments);
}

/**
 * 资源范围设置
 * @param data
 * @returns {*}
 */
function _loadCompanyWorkPlanTypeDict() {
  _loadCompanyWorkPlanTypeDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var params,
      _yield$request,
      content,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          params = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _context5.prev = 1;
          _context5.next = 4;
          return request({
            url: 'api/csCompany/type/page',
            method: 'get',
            params: _objectSpread({
              page: 1,
              size: 999999
            }, params)
          });
        case 4:
          _yield$request = _context5.sent;
          content = _yield$request.content;
          return _context5.abrupt("return", (content || []).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              value: item.id,
              label: item.name
            });
          }));
        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5["catch"](1);
          return _context5.abrupt("return", []);
        case 12:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[1, 9]]);
  }));
  return _loadCompanyWorkPlanTypeDict.apply(this, arguments);
}
export function resourcesAdd(data) {
  return request({
    url: 'api/csCompany/resources/setting',
    method: 'post',
    data: data
  });
}
export function serviceMenuParty() {
  return request({
    url: 'api/gzhMenu/serviceMenuParty',
    method: 'get'
  });
}
export function clientMenuParty() {
  return request({
    url: 'api/gzhMenu/clientMenuParty',
    method: 'get'
  });
}
export function clientRoleMenuParty(bizId) {
  return request({
    url: 'api/gzhMenu/clientRoleMenu?bizId=' + bizId,
    method: 'get'
  });
}
export function qrcodeMenuParty() {
  return request({
    url: 'api/gzhMenu/qrcodeMenuParty',
    method: 'get'
  });
}
export function superviseMenuParty() {
  return request({
    url: 'api/gzhMenu/superviseMenuParty',
    method: 'get'
  });
}
export function addGzhAuth(data) {
  return request({
    url: 'api/gzhMenu/auth',
    method: 'post',
    data: data
  });
}
export function addGzhAuthRole(data) {
  return request({
    url: 'api/gzhMenu/authRole',
    method: 'post',
    data: data
  });
}
export function authDetail(bizId) {
  return request({
    url: 'api/gzhMenu/auth/detail?bizId=' + bizId,
    method: 'get'
  });
}
export function authDetailRole(roleId) {
  return request({
    url: 'api/gzhMenu/auth/detailRole?roleId=' + roleId,
    method: 'get'
  });
}
export default {
  add: add,
  edit: edit,
  del: del,
  detail: detail,
  getMenusTree: getMenusTree,
  treeAuth: treeAuth,
  menuAdd: menuAdd,
  selectParty: selectParty,
  selectCompany: selectCompany,
  enable: enable,
  disable: disable,
  selectTree: selectTree,
  typeAdd: typeAdd,
  typeAuth: typeAuth,
  loadCompanyWorkPlanTypeDict: loadCompanyWorkPlanTypeDict,
  resourcesAdd: resourcesAdd,
  serviceMenuParty: serviceMenuParty,
  clientMenuParty: clientMenuParty,
  qrcodeMenuParty: qrcodeMenuParty,
  superviseMenuParty: superviseMenuParty,
  addGzhAuth: addGzhAuth,
  authDetail: authDetail,
  clientRoleMenuParty: clientRoleMenuParty,
  authDetailRole: authDetailRole,
  addGzhAuthRole: addGzhAuthRole
};